import MemberOf from './MemberOf.component';

export default MemberOf;
